import { defineStore } from 'pinia';
import { defaultStag } from '~/config/constants.config';
import { EPlayerWritableGroup } from '~/types/vip';
import { useStoreSsPlayer } from '../softswiss/player';
import { useStoreStag } from './stag';

const LOCAL_STORAGE_SEO_REFERRER_GROUP = 'seo-referrer-group';

export const useStoreSeoReferrer = defineStore('StoreSeoReferrer', {
  state: () => ({
    group: '' as EPlayerWritableGroup,
  }),
  getters: {
    isReferrerGroup(state): boolean {
      return Boolean(state.group);
    },
    referrerGroup(state): EPlayerWritableGroup {
      return state.group;
    },
  },
  actions: {
    checkReferrer() {
      const savedGroup = localStorage && localStorage.getItem(LOCAL_STORAGE_SEO_REFERRER_GROUP);
      if (savedGroup) {
        this.group = savedGroup as EPlayerWritableGroup;
        return;
      }

      const storeStag = useStoreStag();

      const storeSsPlayer = useStoreSsPlayer();

      if (
        !import.meta.browser ||
        storeSsPlayer.isPlayerAuthorised ||
        (storeStag.currentStag && storeStag.currentStag !== defaultStag)
      ) {
        return;
      }

      const referrer = document.referrer;
      let group = '' as EPlayerWritableGroup;

      switch (true) {
        case /^http(s)?:\/\/(www\.)?(google)./.test(referrer):
          group = EPlayerWritableGroup.SEO_GOOGLE;
          break;

        case /^http(s)?:\/\/(www\.)?(bing)\.(com)/.test(referrer):
          group = EPlayerWritableGroup.SEO_BING;
          break;

        case /^http(s)?:\/\/(www\.)?([\w\d._-]+\.)?(yahoo)\.(com)/.test(referrer):
          group = EPlayerWritableGroup.SEO_YAHOO;
          break;

        case /^http(s)?:\/\/(www\.)?(yandex)\.(ru|kz|by|lv)/.test(referrer):
          group = EPlayerWritableGroup.SEO_YANDEX;
          break;

        case /^http(s)?:\/\/(www\.)?(duckduckgo)\.(com)/.test(referrer):
          group = EPlayerWritableGroup.SEO_DUCKDUCKGO;
          break;

        case /^http(s)?:\/\/(www\.)?(baidu)\.(com)/.test(referrer):
          group = EPlayerWritableGroup.SEO_BAIDU;
          break;

        case /^http(s)?:\/\/(www\.)?(ecosia)\.(com|org)/.test(referrer):
          group = EPlayerWritableGroup.SEO_ECOSIA;
          break;

        case /^http(s)?:\/\/(www\.)?(search\.ask|ask)\.(com|org)/.test(referrer):
          group = EPlayerWritableGroup.SEO_SEARCH_ASK_COM;
          break;

        // no default
      }

      if (group) {
        this.group = group;
        if (localStorage) {
          localStorage.setItem(LOCAL_STORAGE_SEO_REFERRER_GROUP, group);
        }
      }
    },
  },
});
